import React, {FC} from "react";
import {TextField,TextFieldProps} from '@mui/material';
// import './TextField.scss';

type TProps = TextFieldProps
export const InputForm:FC<TProps> = function (props: TProps) {
    return ( <TextField variant={'outlined'}  {...props} /> )

}

